import React from 'react';
import type { UserMonitorConfig } from '../../../types/UserMonitorConfig';
import styles from './NavBar.module.css';

interface NavBarProps {
  userConfig: UserMonitorConfig;
  isConfigured: boolean;
  onMyMonitorClick?: () => void;
}

export function NavBar({ userConfig, isConfigured, onMyMonitorClick }: NavBarProps) {
  return (
    <header className={styles.navbar}>
      <div className={styles.inner}>
        {/* Brand */}
        <div className={styles.brand}>
          <svg
            className={styles.brandIcon}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            aria-hidden="true"
          >
            <rect x="1" y="3" width="14" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
            <path d="M5 13.5v1.5M11 13.5v1.5M3 15h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          <span className={styles.brandName}>Monitor Tools</span>
        </div>

        {/* Your display widget */}
        <button
          className={`${styles.displayWidget} ${!isConfigured ? styles.displayWidgetUnconfigured : ''}`}
          onClick={onMyMonitorClick}
          aria-label="Configure your current physical display"
        >
          <span className={styles.displayWidgetLabel}>Your current physical display</span>
          {isConfigured ? (
            <span className={styles.displayWidgetValue}>
              {userConfig.diagonalInches}&quot;&thinsp;&middot;&thinsp;{userConfig.nativeResolutionW}&thinsp;&times;&thinsp;{userConfig.nativeResolutionH}&thinsp;&middot;&thinsp;{userConfig.scalingLogicalW}&thinsp;&times;&thinsp;{userConfig.scalingLogicalH}&thinsp;logical
            </span>
          ) : (
            <span className={styles.displayWidgetCta}>Set up your display &rsaquo;</span>
          )}
        </button>
      </div>
    </header>
  );
}
